import { isCordova, isCordovaDebug } from "./mobile/util/mobileUtil";

import './scss/main.scss';

(async function () {
    await import('./scss/def-' + process.env.REACT_APP_PROVIDER + '.css');
    if (isCordova() || isCordovaDebug()) {
        await import('./mobile/index');
        return;
    }
    await import('./index-full');
})();